import TagManager from "react-gtm-module";
import { getConfig } from "@config/index";

interface IUserInfo {
  userId: string;
}

const setupAnalytics = (userInfo: IUserInfo = { userId: "" }) => {
  const tagManagerArgs = {
    gtmId: getConfig().GOOGLE_TAG_MANAGER_ID,
    dataLayerName: "PageDataLayer",
    dataLayer: {
      userId: userInfo.userId,
      userProject: "MunshifyForms",
    },
  };
  TagManager.initialize(tagManagerArgs);
};

export default setupAnalytics;
